import axios from "@/utils/axios";
import problem from "@/utils/question";
import { question , setReport , setsetReportToken , lastInfo , gov_token , fivesix , congenital } from "@/api";
import { ages , RandomString } from "@/utils";
import { audioPaly } from "@/utils";
import { fenxiing } from "@/utils/audio";
import { Notify } from 'vant';

let device = {
    namespaced: true,
    state: {
        problem:{
            renovate:true,
            data:[]
        },              // 问题数组
        tyle:1,         // 1是全部展示   2是一题一页展示
        page:0,         // 一页一题的页数，全部展示无效
        unique_token:RandomString(16),   //随机数,
        flow_base:0,
        show:false,
        token:'',
        loading:false,
        xtjk:'',
        wylq:'',
        hours:true
    },
    mutations: {
        //整理基础问题
        questions(state){
            //根据后端数据展示基础数据，默认[1,2,3,4]
            let flow = sessionStorage.getItem('flow');
            let flow_base = "";     //基础问题列表
            let flow_step = "";     //评估组合
            if(flow){
                flow_base = JSON.parse(flow).base_info;
                //获取问诊的展示方式
                state.tyle = JSON.parse(flow).flow_info.consultation_style;
                flow_step = JSON.parse(flow).flow_info.flow_step;
            }

            //flow_base = flow_base?flow_base:[1,2,3,4];
            
            // flow_base = [1,3,4,8,9];
            // let info = sessionStorage.getItem('info');
            // if(info){
            //     flow_base = [3,4,8,9];
            // }

            let info = sessionStorage.getItem('info');
            info = JSON.parse(info);
            console.log(info);
            if(info){
                flow_base = flow_step==19||flow_step==20?[10]:[9];
                if(!info.gender){
                    flow_base.push(1);
                }
                if(!info.height){
                    flow_base.push(3);
                }
                if(!info.weight){
                    flow_base.push(4);
                }
                if(!info.waistSize){
                    if(flow_step!==19 && flow_step!==20){
                        flow_base.push(8);
                    }
                }
                flow_base.sort((a, b) => a - b);
            }else{
                flow_base =  flow_step==19||flow_step==20?[1,2,3,4,10]:[1,2,3,4,8,9];
            }

            if(flow_step==19||flow_step==20){
                state.hours = false;
            }

            console.log(flow_base);

            state.flow_base = flow_base.length;
            let matter = [];
            //查询需要展示的基础信息
            for(let i=0,n=problem.length;i<n;i++){
                for(let k=0,j=flow_base.length;k<j;k++){
                    if(problem[i].dockId==flow_base[k]){
                        problem[i].content.map((cont,index)=>{
                            if(typeof cont == 'string'||(problem[i].dockId==2)){
                                if(problem[i].content.length>1){
                                    problem[i].content = ['','','','00','00'];
                                    problem[i].date = 0;
                                }else{
                                    problem[i].content = [''];
                                }
                            }else{
                                problem[i].content[index].active = false;
                            }
                        })
                        matter.push(problem[i]);
                        break;
                    }
                }
            }

            //获取中医问诊题目
            if(!(flow_step=="5"||flow_step=="6"||flow_step=="1"||flow_step=="2")){
                this.dispatch('question/axiosData',{
                    data:{},
                    matter:matter
                })
            }else{
                state.problem.data = matter;
            }
        },
        //改变数值
        change(state,data){
            state[data.key] = data.value;
        },
        //清空
        closeFun(state){
            state.problem = { renovate:!state.problem.renovate, data:[] };
            state.tyle = 1;
            state.page = 0;
            state.unique_token = RandomString(16);
            state.flow_base = 0;
            state.show = false;
            state.token = '';
            state.loading = false;
        },
        //改变页码
        pageChange(state,data){
            //验证问题
            let page = state.page;
            let problem = state.problem.data;
            let bool = false;
            if(page<data.value){
                if(problem[page].no_select){
                    if(problem[page].id==-2){
                        if(problem[page].content[0]&&problem[page].content[1]&&problem[page].content[2]&&problem[page].content[3]&&problem[page].content[4]){
                            bool=true;
                            if(sessionStorage.equipment){
                                let equipment = JSON.parse(sessionStorage.equipment);
                                if(['1LV1VY'].includes(equipment.equipment_code)){
                                    this.dispatch('question/wylqFun',{});    //五运六气
                                    let year = problem[page].content[0];
                                    let month = problem[page].content[1]<10?`0${parseInt(problem[page].content[1])}`:problem[page].content[1];
                                    let day = problem[page].content[2]<10?`0${parseInt(problem[page].content[2])}`:problem[page].content[2];
                                    let hour = problem[page].content[3]<10?`0${parseInt(problem[page].content[3])}`:problem[page].content[3];
                                    let minute = problem[page].content[4]<10?`0${parseInt(problem[page].content[4])}`:problem[page].content[4];
                                    let birthday = `${year}-${month}-${day} ${hour}:${minute}:00`;
                                    this.dispatch('question/xtjkFun',{ birthday: birthday });    //先天健康状态
                                }
                            }
                        }
                    }else{
                        if(problem[page].content[0]){
                            if(problem[page].range[0]<=problem[page].content[0] && problem[page].content[0]<=problem[page].range[1]){
                                bool=true;
                            }else{
                                Notify(problem[page].msg);
                            }
                        }
                    }
                }else{
                    for(let i=0,n=problem[page].content.length;i<n;i++){
                        if(problem[page].content[i].active){
                            bool=true;
                        }
                    }
                }
                if(bool){
                    state.page = data.value;
                }
            }else{
                state.page = data.value;
            }
        },
        //改变problem的值
        problemChange(state,data){
            let problems = state.problem.data;
            if(problems[data.key].no_select){       
                if(problems[data.key].id==-2){      //年月日
                    if(data.value=='清空'){
                        problems[data.key].content = ['','','','00','00'];
                        problems[data.key].date = 0;
                    }else{
                        let vaule = problems[data.key].content;
                        let index = problems[data.key].date;
                        if(data.value<0){
                            if(index>4){
                                problems[data.key].date = 4;
                                index = 4;
                            }
                            let new_vaule = vaule[index].substr(0,vaule[index].length - 1);
                            problems[data.key].content[index]=new_vaule;
                            // 删除键回退
                            // if(new_vaule == '' && index!==0){
                            //     problems[data.key].date = problems[data.key].date-1;
                            // }
                        }else{
                            if(index>4){
                                problems[data.key].date = 4;
                                index = 4;
                            }
                            let new_vaule = `${(index==0 && problems[data.key].content[index].length<4)||problems[data.key].content[index].length<2?problems[data.key].content[index]:''}${data.value}`;
                            if(index!==vaule.length){
                                problems[data.key].content[index]=new_vaule;
                            }
                            if(index==0){   //年
                                if(problems[data.key].content[index].length==4){
                                    if(problems[data.key].content[index]>new Date().getFullYear()){
                                        problems[data.key].content[index] = '';
                                        problems[data.key].date = 0;
                                        Notify('请输入正确的年份！');
                                    }else{
                                        problems[data.key].date = problems[data.key].date+1;
                                    }
                                }
                            }else{          //月日时分
                                let date = problems[data.key].content[index];

                                if( date.length==1 && (index==1 && date>1 ) ||
                                    date.length==1 && (index==2 && date>3 ) ||
                                    date.length==1 && (index==3 && date>6 ) ||
                                    date.length==1 && (index==4 && date>6 ) 
                                ){
                                    problems[data.key].date = problems[data.key].date+1;
                                }else{
                                    if(index!==vaule.length && date.length==2){
                                        if(index==1 && (date>12 || date==0) ){           //月份
                                            problems[data.key].content[index] = '';
                                            problems[data.key].date = 1;
                                            Notify('请输入正确的月份！');
                                        }else if(index==2 && (date>31 || date==0) ){     //日期
                                            problems[data.key].content[index] = '';
                                            problems[data.key].date = 2;
                                            Notify('请输入正确的日期！');
                                        }else if(index==3 && date>24){     //时
                                            console.log(date);
                                            problems[data.key].content[index] = '';
                                            problems[data.key].date = 3;
                                            Notify('请输入正确的小时！');
                                        }else if(index==4 && date>60){     //分
                                            problems[data.key].content[index] = '';
                                            problems[data.key].date = 4;
                                            Notify('请输入正确的分钟！');
                                        }else{
                                            problems[data.key].date = problems[data.key].date+1;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }else{          //输入框
                    if(data.value<0){       //删除
                        let value = `${problems[data.key].content[0]}`;
                        problems[data.key].content[0] = value.substr(0, value.length - 1);
                    }else if(data.value=='清空'){
                        problems[data.key].content[0] = "";
                    }else{      //添加
                        let value = `${problems[data.key].content[0]}${data.value}`;
                        if(value.length<4){
                            problems[data.key].content[0] = `${problems[data.key].content[0]}${data.value}`;
                        }
                    }
                }
            }else{
                //重复选择，撤销选择
                if(problems[data.key].content[data.index].active){
                    problems[data.key].content[data.index].active = false;
                }else{
                    //排它性
                    if(problems[data.key].content[data.index].is_single==1){
                        for(let i=0,n=problems[data.key].content.length;i<n;i++){
                            problems[data.key].content[i].active = false;
                        }
                    }else{
                        for(let i=0,n=problems[data.key].content.length;i<n;i++){
                            if(problems[data.key].content[i].is_single==1){
                                problems[data.key].content[i].active = false;
                            }
                        }
                    }
                    problems[data.key].content[data.index].active = data.value;
                }
            }
            state.problem = {
                renovate:!state.problem.renovate,
                data:problems
            };
        },
        //发送数据请求
        mainAxios(state,params){
            state.problem = {
                renovate:!state.problem.renovate,
                data:params.matter.concat([])
            }
            
            if(sessionStorage.token){   
                this.dispatch('question/lastData'); //获取上一次的问题答案
            }
            // axios (`/api${question}`, params.data).then((data)=>{
            //     if(data.code==1){
            //         state.problem = {
            //             renovate:!state.problem.renovate,
            //             data:params.matter.concat(data.data.list)
            //         }
                    
            //         if(sessionStorage.token){   
            //             this.dispatch('question/lastData'); //获取上一次的问题答案
            //         }
            //     }
            // });
        },
        //获取上一个问题答案
        lastAxios(state){
            let obj = {};
            let red = sessionStorage.red;
            if(red){
                obj.user_id = JSON.parse(red).uid;
            }
            console.log(obj);
            axios (`/api${lastInfo}`,obj).then((data)=>{
                if(data.code == 1){
                    let answer = JSON.parse(data.data.answer);
                    let ABC = ['A','B','C','D','E','F','G','H','I','J','K'];
                    let problem = state.problem.data;
                    answer.map((ans)=>{
                        ans.answer.map((wer)=>{
                            problem.map((blem)=>{
                                let num = ABC.indexOf(wer);
                                if(ans.id == blem.id){
                                    if(num>=0){
                                        blem.content[num].active=true;
                                    }else if(ans.id==-2){
                                        let birthday = data.data.birthday.split(' ');
                                        birthday = birthday[0].split('-').concat(birthday[1].split(':'));
                                        blem.content = birthday;
                                    }else{
                                        blem.content[0]=wer;
                                    }
                                }
                            })
                        })
                    });
                    state.problem = {
                        renovate: !state.problem.renovate,
                        data:problem
                    }
                }
            });
        },
        //提交问诊
        submitAxios(state,params){
            //整理提交
            let problems = state.problem.data;
            let age=0,sex=0,birthday='',height='0',weight='0',fu_wei='0',guo_min=0,face_id='',
                tongue_bottom_id='',
                tongue_id='',answer=[],equipment_code='',sys_company_id=0,
                unique_token='',carte_vital='',id_code='',user_name='',
                check_type=1,user_id=0,yao_account_id=0,server_type=0,wylq=state.wylq,xtjk=state.xtjk;

            let age_son,sex_son,height_son,weight_son,prob_son,fu_wei_son,guo_min_son;
            let ABC = ['A','B','C','D','E','F','G','H','I','J','K'];
            let bool = true;    //验证填写
            let good = true;   //问题
            for(let i=0,n=problems.length;i<n;i++){
                let content = problems[i].content;
                switch(problems[i].id){
                    case -2:      //年龄
                        if(bool){
                            if(!(content[0] && content[1] && content[2] && content[3] && content[4])){
                                bool = false;
                                Notify('请填写出生年月！');
                                break;
                            }
                            
                            content[1] = Number(content[1])>9?Number(content[1]):`0${Number(content[1])}`;
                            content[2] = Number(content[2])>9?Number(content[2]):`0${Number(content[2])}`;
                            content[3] = Number(content[3])>9?Number(content[3]):`0${Number(content[3])}`;
                            content[4] = Number(content[4])>9?Number(content[4]):`0${Number(content[4])}`;

                            age = ages(`${content[0]}-${content[1]}-${content[2]}`);
                            birthday = `${content[0]}-${content[1]}-${content[2]} ${content[3]}:${content[4]}`
                            age_son = {
                                answer:[`${content[0]}-${content[1]}-${content[2]}`],
                                id:-2
                            }
                            answer.push(age_son);
                        }
                        break;
                    case -1:      //性别
                        if(bool){
                            if(!(content[0].active||content[1].active)){
                                bool = false;
                                Notify('请选择性别！');
                                break;
                            }
                            sex = content[0].active?1:2;
                            sex_son = {
                                answer:[`${content[0].active?'A':'B'}`],
                                id:-1
                            }
                            answer.push(sex_son);
                        }
                        break;
                    case -3:      //身高
                        if(bool){
                            if(!(content[0])){
                                bool = false;
                                Notify('请填写身高！');
                                break;
                            }
                            height = content[0];
                            height_son = {
                                answer:[`${content[0]}`],
                                id:-3
                            }
                            answer.push(height_son);
                        }
                        break;
                    case -4:      //体重
                        if(bool){
                            if(!(content[0])){
                                bool = false;
                                Notify('请填写体重！');
                                break;
                            }
                            weight = content[0];
                            weight_son = {
                                answer:[`${content[0]}`],
                                id:-4
                            }
                            answer.push(weight_son);
                        }
                        break;
                    case -8:      //腹围
                        if(bool){
                            if(!(content[0])){
                                bool = false;
                                Notify('请填写腹围！');
                                break;
                            }
                            fu_wei = content[0];
                            fu_wei_son = {
                                answer:[`${content[0]}`],
                                id:-8
                            }
                            answer.push(fu_wei_son);
                        }
                        break;
                    case -9:      //过敏
                        if(bool){
                            guo_min_son = {
                                answer:[],
                                id:problems[i].id
                            }
                            let booly = false;
                            content.map((item,index)=>{
                                if(item.active){
                                    booly = true;
                                    guo_min=index+1;
                                    guo_min_son.answer.push(ABC[index]);
                                }
                            })
                            if(!booly){
                                good = false;
                            }
                            answer.push(guo_min_son);
                        }
                        break;
                    case -10:      //过敏
                        if(bool){
                            guo_min_son = {
                                answer:[],
                                id:problems[i].id
                            }
                            let booly = false;
                            content.map((item,index)=>{
                                if(item.active){
                                    booly = true;
                                    guo_min=index+1;
                                    guo_min_son.answer.push(ABC[index]);
                                }
                            })
                            if(!booly){
                                good = false;
                            }
                            answer.push(guo_min_son);
                        }
                        break;
                    case -5:      //身份证
                        if(bool){
                            if(!(content[0])){
                                bool = false;
                                Notify('请填写身份证！');
                                break;
                            }
                            id_code = content[0];
                        }
                        break;
                    case -6:      //医保卡
                        if(bool){
                            if(!(content[0])){
                                bool = false;
                                Notify('请填写医保卡！');
                                break;
                            }
                            carte_vital = content[0]; 
                        }
                        break;
                    case -7:      //姓名
                        if(bool){
                            if(!(content[0])){
                                bool = false;
                                Notify('请填写姓名！');
                                break;
                            }
                            user_name = content[0];
                        }
                        break;
                    default:
                        if(good){
                            if(problems[i].id>0){
                                prob_son = {
                                    answer:[],
                                    id:problems[i].id
                                }
                                let booly = false;
                                content.map((item,index)=>{
                                    if(item.active){
                                        booly = true;
                                        prob_son.answer.push(ABC[index]);
                                    }
                                })
                                if(!booly){
                                    good = false;
                                }
                                answer.push(prob_son);
                            }
                        }
                }
            }

            answer = JSON.stringify(answer);

            face_id = sessionStorage.getItem('faceID')?sessionStorage.getItem('faceID'):'';
            tongue_id = sessionStorage.getItem('tongueID')?sessionStorage.getItem('tongueID'):'';
            tongue_bottom_id = sessionStorage.getItem('tongueBottomID')?sessionStorage.getItem('tongueBottomID'):'';

            let assess = JSON.parse(sessionStorage.getItem('assess'));
            
            if(assess){
                server_type = assess.server_type;
                user_id = assess.user_id;
                yao_account_id = assess.yao_account_id;
                sys_company_id = Number(assess.sys_company_id);
                
                if(user_id>0){
                    check_type=2
                }
            }

            let equipment = JSON.parse(sessionStorage.getItem('equipment'));
            if(equipment){
                equipment_code = equipment.equipment_code;
                sys_company_id = Number(equipment.sys_company_id);
            }

            //身份证和本地数据
            let info = JSON.parse(sessionStorage.getItem('info'));
            if(info){
                //生日
                if(info.birthday){
                    let info_content = [info.birthday.substring(0,4),info.birthday.substring(5,7),info.birthday.substring(8,10),'00','00'];
                    age = ages(`${info_content[0]}-${info_content[1]}-${info_content[2]}`);
                    birthday = `${info_content[0]}-${info_content[1]}-${info_content[2]} ${info_content[3]}:${info_content[4]}`
                }
                //性别
                if(info.gender){
                    sex = info.gender=='男'?1:2;
                }
                //身高
                if(info.height){
                    height = info.height;
                }
                //体重
                if(info.weight){
                    weight = info.weight;
                }
                //身份证
                if(info.idCode){
                    id_code = info.idCode;
                }
                //姓名
                if(info.userName){
                    user_name = info.userName;
                }
                //腹围
                if(info.waistSize){
                    fu_wei = info.waistSize;
                }
            }
            
            //unique_token = state.unique_token;
            unique_token = RandomString(16);

            let submitData = {
                age,
                sex,
                birthday,
                height,
                weight,
                guo_min,
                fu_wei,
                tongue_bottom_id,
                face_id,
                tongue_id,
                answer,
                equipment_code,
                sys_company_id,
                unique_token,
                carte_vital,
                id_code,
                user_name,
                server_type,
                check_type,
                user_id,
                yao_account_id,
                wylq:wylq?JSON.stringify(wylq):'',
                xtjk
            }
            
            let question_api = sessionStorage.token?setsetReportToken:setReport;
            //如果有手机号
            let phone = sessionStorage.getItem('phone');
            if(phone){
                submitData.phone = phone;
                sessionStorage.removeItem('phone');
            }
            //如果有红包
            let red = JSON.parse(sessionStorage.getItem('red'));
            if(red){
                submitData.user_id = red.uid;
                if(red.red){
                    submitData.hongbao_test_code = red.red;
                }
                sessionStorage.removeItem('red');
            }

            //结算
            let new_card_biaoshi = sessionStorage.getItem('new_card_biaoshi');
            if(new_card_biaoshi){
                submitData.new_card_biaoshi = Number(new_card_biaoshi);
            }

            if(bool){
                if(good){
                    //语音
                    audioPaly.play(fenxiing);
                    state.loading = true;
                    axios (`/api${question_api}`, submitData,'POST').then((data)=>{
                        if(data.code==1){
                            state.loading = false;
                            let flow = sessionStorage.getItem('flow');
                            sessionStorage.removeItem('faceID');
                            sessionStorage.removeItem('tongueID');
                            sessionStorage.removeItem('tongueBottomID');
                            if(flow){
                                let testing_type = JSON.parse(flow).testing_type;
                                if(JSON.parse(flow).flow_info.flow_equipment==15){
                                    params._this.$router.push({
                                        name:'qr_report',
                                        params: {
                                            id:data.data.id
                                        }
                                    });
                                }else 
                                if(testing_type==1){
                                    state.token = data.data.token;
                                    state.show = true;
                                }else if(testing_type==6){
                                    axios(`/govapi${gov_token}`, {
                                        grant_type:'client_credentials',
                                        client_id:'tcm_client',
                                        client_secret:'013e1d01a0ed44f182c2a25cfaded148'
                                    },'POST').then((data1)=>{
                                        if(!data1.code){
                                            sessionStorage.setItem("govReport",data1.access_token);
                                            params._this.$router.push({
                                                name:'report',
                                                params: {
                                                    id:data.data.token
                                                }
                                            });
                                        }
                                    });
                                }else{
                                    //sessionStorage.removeItem('assess');
                                    params._this.$router.push({
                                        name:'report',
                                        params: {
                                            id:data.data.token
                                        }
                                    });
                                }
                            }else{
                                params._this.$router.push({
                                    name:'report',
                                    params: {
                                        id:data.data.token
                                    }
                                });
                            }
                        }else{
                            state.loading = false;
                            Notify(data.msg);
                        }
                    });
                }else{
                    Notify('请填写问诊问题！');
                }
            }
        },
        //五运六气
        WylqReport(state,params){
            axios(`/kfApi${fivesix}`,params).then((data)=>{
                if(data.code==1){
                    state.wylq = data.data;
                }
            });
        },
        //先天健康状态
        XtjkReport(state,params){
            axios(`/kfApi${congenital}`,params).then((data)=>{
                if(data.code==1){
                    state.xtjk = data.data.content;
                }
            });
        }
    },
    actions: {              //异步方法
        axiosData({commit},params){
            commit('mainAxios',params)
        },
        submitData({commit},params){
            commit('submitAxios',params)
        },
        lastData({commit}){
            commit('lastAxios')
        },
        wylqFun({commit},params){
            commit('WylqReport',params)
        },
        xtjkFun({commit},params){
            commit('XtjkReport',params)
        }
    },
    getters: {},
}

export default device;
